import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import "./ChatbotSIPUMA.css";

const ChatbotSIPUMA = () => {
  const defaultMessage = [
    {
      sender: "bot",
      text: "Halo! Saya adalah layanan asisten virtual bertenaga AI. Ada yang bisa saya bantu terkait pelacakan status laporan atau panduan regulasi?"
    }
  ];

  const [messages, setMessages] = useState(() => {
    const savedMessages = localStorage.getItem("sipuma_chat_ui_history");
    return savedMessages ? JSON.parse(savedMessages) : defaultMessage;
  });

  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const getOrCreateSessionId = () => {
    let id = localStorage.getItem("sipuma_session_id");
    if (!id) {
      id = "session-" + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      localStorage.setItem("sipuma_session_id", id);
    }
    return id;
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    localStorage.setItem("sipuma_chat_ui_history", JSON.stringify(messages));
    scrollToBottom();
  }, [messages, isTyping]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userText = input;
    setInput("");

    setMessages((prev) => [...prev, { sender: "user", text: userText }]);
    setIsTyping(true);

    const sessionId = getOrCreateSessionId();

    try {
      const response = await axios.post("http://localhost:8080/api/chatbot/ask", {
        message: userText,
        sessionId: sessionId
      });

      if (response.data && response.data.reply) {
        setMessages((prev) => [...prev, { sender: "bot", text: response.data.reply }]);
      } else {
        setMessages((prev) => [...prev, { sender: "bot", text: "Maaf, sistem AI tidak merespon." }]);
      }
    } catch (err) {
      console.error(err);
      setMessages((prev) => [...prev, { sender: "bot", text: "Gagal tersambung dengan server AI." }]);
    } finally {
      setIsTyping(false);
    }
  };

  const handleClearChat = () => {
    if (window.confirm("Yakin ingin menghapus riwayat obrolan ini?")) {
      setMessages(defaultMessage);
      localStorage.removeItem("sipuma_chat_ui_history");
    }
  };

  return (
    <div className="sipuma-container">
      {/* HEADER */}
      <div className="sipuma-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <h4 style={{ margin: 0 }}>SIPUMA Assistant AI</h4>
          <p style={{ margin: 0, fontSize: "0.85rem" }}>Layanan Proteksi Privasi & Konsultasi Pengaduan Aman</p>
        </div>
        <button
          onClick={handleClearChat}
          style={{
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.5)",
            color: "white",
            borderRadius: "5px",
            padding: "6px 12px",
            cursor: "pointer",
            fontSize: "0.8rem",
            transition: "0.2s"
          }}
          onMouseOver={(e) => e.target.style.background = "rgba(255,255,255,0.1)"}
          onMouseOut={(e) => e.target.style.background = "transparent"}
        >
          Hapus Obrolan
        </button>
      </div>

      {/* CHAT AREA */}
      <div className="sipuma-chatbox">
        {messages.map((msg, index) => (
          <div key={index} className={`sipuma-message ${msg.sender}`}>
            <div className="bubble">
              <ReactMarkdown>{msg.text}</ReactMarkdown>
            </div>
          </div>
        ))}

        {/* LOADING TYPING ANIMATION (Tiga Titik) */}
        {isTyping && (
          <div className="sipuma-message bot">
            <div className="bubble typing-bubble">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* INPUT */}
      <form className="sipuma-input" onSubmit={handleSend}>
        <input
          type="text"
          placeholder="Tanyakan status tiket pengaduan atau aturan kepabeanan..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          disabled={isTyping}
        />
        <button type="submit" disabled={isTyping} aria-label="Kirim"></button>
      </form>
    </div>
  );
};

export default ChatbotSIPUMA;